import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { media } from 'ui/rwd'
import {
  TopSection,
  LinkColumn,
  LinkFooterExternal,
  Description,
  LinksCluster as BaseLinksCluster
} from '../../../components/layout/Footer/FooterStyledComponents'

const PageFooter = styled.footer`
  background-color: ${theme('black')};
  width: 100%;
  font-size: 1.8rem;
  text-align: left;
`

const FooterTop = styled(TopSection)`
  ${media.md`
    grid-template-columns: minmax(220px, 1fr) minmax(0, 2.2fr);
  `}
`

const LinksCluster = styled(BaseLinksCluster)`
  grid-template-columns: repeat(2, minmax(0, 1fr));
`

const FooterColumn = styled(LinkColumn)`
  min-width: 0;
`

const FooterEmail = styled(LinkFooterExternal)`
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
`

const LegalAddress = styled(Description)`
  white-space: pre-line;
`

export { PageFooter, FooterTop, FooterColumn, FooterEmail, LegalAddress, LinksCluster }
